import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { useState } from 'react';
import cx from 'classnames';
import { F as FeedbackTooltip } from './FeedbackTooltip-fe34aaac.js';
import InputIcon from './inputIcon.js';

var styles = {"mw-input":"Input_mw-input__3POcS","tooltip":"Input_tooltip__fwRTr","mw-input-light":"Input_mw-input-light__2itkB","mw-input-icon":"Input_mw-input-icon__TKGda","mw-input-select":"Input_mw-input-select__3fJ2m","motorway-svg-fill":"Input_motorway-svg-fill__2Swp0","motorway-svg-stroke":"Input_motorway-svg-stroke__1K8cn","mw-input-intent-success":"Input_mw-input-intent-success__bBDQI","mw-input-vrm":"Input_mw-input-vrm__1CR3q","mw-input-vrm-white":"Input_mw-input-vrm-white__3Iz_l","mw-input-vrm-large":"Input_mw-input-vrm-large__MIa-z","mw-input-vrm-large-white":"Input_mw-input-vrm-large-white__zEMwa","mw-input-disabled":"Input_mw-input-disabled__28azs","mw-input-intent-error":"Input_mw-input-intent-error__agl35","mw-input-icon-loading":"Input_mw-input-icon-loading__11_Io","mw-input-loading":"Input_mw-input-loading__3IyDl","mw-input-add":"Input_mw-input-add__3Kq5h","mw-input-search":"Input_mw-input-search__1-QN7","mw-input-money":"Input_mw-input-money__1W0Oe","mw-form-control":"Input_mw-form-control__nGAEq","mw-input-number":"Input_mw-input-number__2nE3y","mw-container-prefix":"Input_mw-container-prefix__10qYi","mw-input-suffix":"Input_mw-input-suffix__3xNvj","mw-input-intent-warning":"Input_mw-input-intent-warning__1vMrZ","labelPrefix":"Input_labelPrefix__3OEJq","mw-container-prefix-focused":"Input_mw-container-prefix-focused__3Qejq"};

const PRIMITIVE_TYPES = ['text', 'email', 'search', 'number', 'password'];
const Input = props => {
  const [wrapperRef, setWrapperRef] = useState(null);
  const {
    className,
    id,
    label,
    labelProps,
    inputProps,
    intent = 'none',
    money,
    suffix,
    type: typeProp,
    feedbackTooltip = {}
  } = props;
  let rightIcon = typeProp === 'select' ? 'select' : typeProp;
  let typeForInput = PRIMITIVE_TYPES.includes(typeProp) ? typeProp : 'text';
  if (!id) {
    console.warn(`Input element with the label "${label}" needs an ID attribute to associate label with the input`);
  }
  let intentClass = '';
  switch (intent) {
    case 'success':
      intentClass = 'mw-input-intent-success';
      if ((typeProp || '').startsWith('vrm') === false) {
        rightIcon = 'validate-success';
      }
      break;
    case 'warning':
      intentClass = 'mw-input-intent-warning';
      break;
    case 'error':
      intentClass = 'mw-input-intent-error';
      break;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx('mw-input', `mw-input-${typeProp || 'text'}`, {
      'mw-input-money': money
    }, intentClass, className)
  }, label && /*#__PURE__*/React__default.createElement("label", _extends({
    htmlFor: id
  }, labelProps), label), /*#__PURE__*/React__default.createElement(FeedbackTooltip, {
    intent: intent,
    appendTo: wrapperRef,
    content: feedbackTooltip.content,
    tooltipIcon: feedbackTooltip.tooltipIcon,
    placement: feedbackTooltip.placement,
    placementFlipped: feedbackTooltip.placementFlipped,
    fillWidth: feedbackTooltip.fillWidth,
    tooltipWithinParent: feedbackTooltip.tooltipWithinParent
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: setWrapperRef,
    className: "mw-form-control"
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    id: id,
    className: "mw-input"
  }, inputProps, {
    type: typeForInput
  })), rightIcon && /*#__PURE__*/React__default.createElement(InputIcon, {
    icon: rightIcon
  }))), suffix && /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: "mw-input-suffix"
  }, suffix));
};

export { Input as I, Input as a, styles as s };
